export default __webpack_public_path__ + "static/media/entertainment-tour.06473231.png";